import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TurnSlightRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"turn_slight_right"}/>
}
